import React from "react";

import { VStack } from "@UI/Components/Stack/Stack";
import { Text } from "@UI/Components/Text/Text";
import { ICandidate } from "../../types";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Rate } from "@Shared/Components/Rate/Rate";

export const CandidateOfferSection = (props: ICandidate) => {
  return (
    <VStack
      spacing="4px"
      alignSelf={{
        base: "start",
        lg: !props?.serviceOffer ? "flex-start" : "center",
      }}
      alignItems="flex-end"
      textAlign="end"
    >
      {!props?.serviceOffer ? (
        <Text fontSize={{ base: "0.75rem", md: "0.875rem" }}>
          <FormattedMessage
            {...messages[
              props.offerWithdrawn || props.offerAsked
                ? props.offerWithdrawn
                  ? "serviceRequest.offerWithdrawn"
                  : "serviceRequest.offerAsked"
                : "serviceRequest.noOffer"
            ]}
          />
        </Text>
      ) : (
        <>
          <Text
            as="h5"
            fontWeight="bold"
            fontSize={{ base: "1.125rem", md: "1.5rem" }}
            m="0"
          >
            <Rate
              unit={props?.serviceOffer?.billingUnit}
              cents={props?.serviceOffer?.rateCents}
              currency={props?.serviceOffer?.rateCurrency}
            />
          </Text>
          {props?.serviceOffer?.billingUnit && (
            <Text
              lineHeight="18px"
              fontSize={{ base: "0.75rem", md: "0.875rem" }}
            >
              <FormattedMessage
                {...messages[props?.serviceOffer?.billingUnit]}
              />
            </Text>
          )}

          {props?.serviceOffer?.offersFreeEstimation && (
            <Text
              as="h5"
              fontWeight="bold"
              fontSize={{ base: "0.75rem", md: "0.875rem" }}
            >
              <FormattedMessage
                {...messages["serviceRequest.offerDetail.freeVisit"]}
              />
            </Text>
          )}
        </>
      )}
    </VStack>
  );
};
